// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './ShareButton.less';
import { shareLinkClicked } from 'src/store/jobdetails/jobdetails';

import omit from 'lodash/omit';

const mapDispatchToProps = {
  onClick: shareLinkClicked
};

type Props = {
  href: string,
  icon: Function,
  popupWidth: number,
  popupHeight: number,
  onClick: Function,
  type: string,
  title: string
};

class ShareButtons extends Component<Props> {
  prop: Props;

  handleClick = (event: SyntheticEvent<HTMLAnchorElement>) => {
    const { href, popupWidth, popupHeight, onClick, type } = this.props;

    onClick(type);

    event.preventDefault();
    window.open(
      href,
      'sharer',
      `toolbar=0,status=0,width=${popupWidth},height=${popupHeight}`
    );
  };

  render() {
    const { icon: IconComponent, ...props } = this.props;
    return (
      <a
        {...omit(props, ['popupWidth', 'popupHeight', 'onClick', 'type'])}
        className={styles.link}
        onClick={this.handleClick}
      >
        <IconComponent svgClassName={styles.iconSvg} />
      </a>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(ShareButtons);
